import { render, staticRenderFns } from "./hotelMessage.vue?vue&type=template&id=47985d90&"
import script from "./hotelMessage.vue?vue&type=script&lang=js&"
export * from "./hotelMessage.vue?vue&type=script&lang=js&"
import style0 from "./hotelMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports